/**
 * This is a Semantic UI dropdown selector.
 * It also features a quick search.
 * This is being set up to be controlled by redux-form
 */

import React from 'react';
import PropTypes from 'prop-types';
import { REJECT_REASONS } from 'common';
import { Dropdown, Popup } from 'semantic-ui-react';
import messages from './messages';

const rejectionOptions = REJECT_REASONS.map((reason) => ({ key: reason, value: reason, text: messages[reason].defaultMessage }));

const DropDownSemanticUI = ({ input, meta: { touched, error } }) => (
  <Popup
    content={error}
    open={touched && !!error}
    position="bottom left"
    trigger={
      <Dropdown
        required
        openOnFocus
        fluid
        search
        selection
        value={input.value}
        options={rejectionOptions}
        onChange={(e, { value }) => (input.onChange(value))}
      />
    }
  />
);


DropDownSemanticUI.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default DropDownSemanticUI;



// WEBPACK FOOTER //
// ./src/components/RejectTransferForm/DropDownSemanticUI.js